import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "name",
  "use": "name-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"name\"><path d=\"M6 17c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1Zm6-5a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol